import type { SettingsResponse } from "app/@types/settings.types";
import { DefaultFetchService, NoCacheHeaders } from "app/services/fetchService";

export const ADDON_HISTORICAL_DATA_FROM_QUERY = "addonHistoricalData";

export const fetchComponents = async (componentId: Array<string>): Promise<SettingsResponse> => {
    const shouldUpdateForce = window.location.search.includes(ADDON_HISTORICAL_DATA_FROM_QUERY);
    const fetchService = DefaultFetchService.getInstance();
    return fetchService.post<SettingsResponse>(`/settings?force=${shouldUpdateForce}`, componentId, {
        headers: NoCacheHeaders,
        preventAutoCancellation: true,
    });
};
